import { useCookies } from 'react-cookie';
import { Trans } from 'react-i18next';

import styled from '@emotion/styled';
import { getServiceName } from '@repo/utils';
import { t } from 'i18next';

import { StackedModalProps, useModalFlag, useModalStackStore } from 'store/modalStackStore';

import Flex from 'components/util/Flex';

import { getExpiredDate } from 'pages/dashboard/utils/getExpiredDate';

interface ChangeBubblePauseModalProps extends StackedModalProps {
  hasCloseEverButton?: boolean;
}

const ChangeBubblePauseModal = ({ hasCloseEverButton }: ChangeBubblePauseModalProps) => {
  const expires = getExpiredDate(9999);
  const [cookies, setCookie] = useCookies();
  const { closeModal } = useModalStackStore();
  const modalFlag = useModalFlag();

  const handleCloseModal = () => {
    modalFlag.setFlag(true);
    closeModal();
  };

  const handleCloseForever = async () => {
    if (cookies.USER_SET_REWARD_PAUSE_EXPIRES) return;
    setCookie(`USER_SET_REWARD_PAUSE_EXPIRES`, 'until_forever', { expires });
    handleCloseModal();
  };

  return (
    <SChangeBubblePauseModal>
      <SUnAvailableChangeBubbleHeader align="center" justify="center">
        <p className="title">
          <Trans i18nKey={'chat.rewards_no_transferable_alert_title'} />
        </p>
        <p className="description">{t('chat.rewards_no_transferable_alert_description')}</p>
      </SUnAvailableChangeBubbleHeader>
      {hasCloseEverButton ? (
        <SButtonSection>
          <SCancelButton onClick={handleCloseForever}>
            {t('chat.rewards_total_revenue_time_update_alert_button1')}
          </SCancelButton>
          <SAllowButton onClick={handleCloseModal} $isTingle={getServiceName() === 'tingle'}>
            {t('chat.rewards_total_revenue_time_update_alert_button2')}
          </SAllowButton>
        </SButtonSection>
      ) : (
        <Flex justify="center">
          <SButton onClick={handleCloseModal} $isTingle={getServiceName() === 'tingle'}>
            {t('chat.rewards_no_transferable_alert_ok_button')}
          </SButton>
        </Flex>
      )}
    </SChangeBubblePauseModal>
  );
};

const SChangeBubblePauseModal = styled.div`
  width: 100%;
  padding: 40px 36px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`;

const SUnAvailableChangeBubbleHeader = styled(Flex)`
  gap: 8px;
  flex-direction: column;
  .title {
    ${({ theme }) => theme.font.head5_sb};
    font-family: Pretendard;
    text-align: center;
  }
  .description {
    ${({ theme }) => theme.font.body2_r};
    font-family: Pretendard;
    text-align: center;
  }
`;

// 팅글 리워드 CTA: yellow/black (임시, 디자인 제안 Figma 1072:58012). 버블챗은 기존 primary/white 유지
const SButton = styled.button<{ $isTingle?: boolean }>`
  padding: 12px 0;
  width: 260px;
  border-radius: 8px;
  background-color: ${({ theme, $isTingle }) => ($isTingle ? theme.color.brand.primary : theme.color.static.primary)};
  color: ${({ theme, $isTingle }) => ($isTingle ? '#000000' : theme.color.static.white)};
  ${({ theme }) => theme.font.body1_m};
`;

const SButtonSection = styled.div`
  gap: 10px;
  flex: 1 0 0;
  display: flex;
  align-items: flex-start;
`;

const Button = styled.button`
  width: 130px;
  padding: 12px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  ${({ theme }) => theme.font.body1_r};
`;

const SCancelButton = styled(Button)`
  background-color: transparent;
  color: ${({ theme }) => theme.color.text.TXT_1};
  border: 1px solid ${({ theme }) => theme.color.line.line_2};
`;

// 팅글 리워드 CTA: yellow/black (임시, 디자인 제안 Figma 1072:58012). 버블챗은 기존 primary/white 유지
const SAllowButton = styled(Button)<{ $isTingle?: boolean }>`
  border-radius: 8px;
  color: ${({ theme, $isTingle }) => ($isTingle ? '#000000' : theme.color.static.white)};
  background: ${({ theme, $isTingle }) => ($isTingle ? theme.color.brand.primary : theme.color.static.primary)};
`;

export default ChangeBubblePauseModal;
